<template>
    <div class="table_wrap pb10">
        <div class="btn_wrap pa10 text_right">
            <el-button type="save" @click="addBanner">배너 추가</el-button>
        </div>
        <div class="el-table list-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition el-table__body-wrapper is-scrolling-none">
            <div class="">
                <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;" class="el-table__header">
                    <colgroup>
                        <col width="">
                        <col width="300">
                        <col width="">
                        <col width="">
                        <col width="200">
                    </colgroup>
                    <thead class="has-gutter">
                        <tr>
                            <th class="is-leaf list-header">
                                <div class="cell">이미지</div>
                            </th>
                            <th class="is-leaf list-header">
                                <div class="cell">링크</div>
                            </th>
                            <th class="is-leaf list-header">
                                <div class="cell">노출유무</div>
                            </th>
                            <th class="is-leaf list-header">
                                <div class="cell">노출순서</div>
                            </th>
                            <th class="is-leaf list-header">
                                <div class="cell">옵션</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="bannerData.length === 0">
                            <td colspan="5">
                                <div class="cell text-center">
                                    데이터가 없습니다.
                                </div>
                            </td>
                        </tr>
                        <tr v-for="(banner, index) in bannerData" :key="`banner${index}`" class="el-table__row">
                            <td>
                                <div class="cell text-center" @click="changeType(`bannerData[${index}]File`)">
                                    <el-upload
                                        v-if="!(changeData && selectIndex === index) || !allChangeData"
                                        class="avatar-uploader banner-image"
                                        action=""
                                        list-type="picture-card"
                                        :show-file-list="false"
                                        :file-list="banner.File"
                                        :auto-upload="false"
                                        :on-change="onlyOnePhotoChange"
                                    >
                                        <img v-if="hasImage(banner)" :src="returnImageUrl(banner)" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        <div slot="tip" class="el-upload__tip c_danger">jpg/png 종류의 파일과 10MB 이하의 파일만 가능합니다.</div>
                                    </el-upload>
                                </div>
                            </td>
                            <td>
                                <div class="cell text-center">
                                    <div style="width: 250px; display: inline-block;">
                                        <el-input v-model="banner.b_url" ></el-input>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="cell text-center">
                                    <el-select v-model="banner.b_is_show">
                                        <el-option :value="0" :label="'미노출'"></el-option>
                                        <el-option :value="1" :label="'노출'"></el-option>
                                    </el-select>
                                </div>
                            </td>
                            <td>
                                <div class="cell text-center">
                                    <div style="width: 150px; display: inline-block;">
                                        <el-input v-model="banner.b_seq" @blur="replaceNumber(banner.b_seq, index)"></el-input>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="cell text-center">
                                    <div class="row-info">
                                        <el-button @click="runSave(banner, index)">
                                            저장
                                        </el-button>
                                        <el-button @click="openRemoveConfirm(banner.b_idx, index)">
                                            삭제
                                        </el-button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import util from "@/mixins/util";
import imageOption from "@/mixins/imageOption";
import elFileMixins from "@/mixins/elFileMixins";
import DeleteClass from "@/mixins/deleteClass";
import EventBus from "@/utils/event-bus";


export default {
    name: "BannerComponent",
    mixins: [elFileMixins, imageOption],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            beforeBannerData: [],
            bannerData: [],
            keyName: 'b_idx',
            DeleteClass: null,
            selectIndex: null,
            changeData: false,
            allChangeData: false,
            isRunning: false,
        }
    },
    created() {
        this.newDeleteClass();
        this.getList()
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        changeLoading(value) {
            this.isRunning = value;
            EventBus.$emit('apiLoading', value);
        },
        newDeleteClass() {
            let deleteOptions = {
                func: this.$api.$banner.deleteBanner,
                apiParamSet: {},
                keyName: this.keyName,
                successType: 1,
                errorTypes: {
                    '-403' : '권한이 없습니다.'
                },
                afterFunc: this.deleteAfterFunc,
            }
            this.DeleteClass = new DeleteClass(deleteOptions);
        },
        getList() {
            let params = {
                ip: 0,
                odc : 'created_at',
                odd: 'desc',
                ity: 'banner'
            }
            this.$api.$banner.getBanner(params).then(res => res.Data.Result).then(res => {
                if(!util.isEmpty(res.List)) {
                    this.beforeBannerData = JSON.parse(JSON.stringify(res.List));
                    this.bannerData = res.List;
                }
            })
        },
        deleteAfterFunc(key) {
            let bannerIndex = this.bannerData.findIndex(banner => banner[this.keyName] === key);
            if(bannerIndex > -1) {
                this.bannerData.splice(bannerIndex, 1);
            }
            let beforeBannerIndex = this.beforeBannerData.findIndex(bb => bb.b_idx == key);
            if(beforeBannerIndex > -1) {
                this.beforeBannerData.splice(beforeBannerIndex, 1);
            }
            this.$nextTick(() => {
                this.allChangeData = false;
            })
        },
        hasImage(banner) {
            return !util.isEmpty(banner.File)
        },
        returnImageUrl(banner) {
            if(!util.isEmpty(banner.File[0].url)) {
                return banner.File[0].url
            }
            return `${banner.File[0].org_url}?${this.setImageOptions(720, 404, 'png')}`;
        },
        replaceNumber(value, index) {
            var pattern = /[^(0-9)]/gi;   // 숫자이외는 제거

            if(pattern.test(value)) {
                this.bannerData[index].b_seq = value.replace(pattern, "");
                if(this.bannerData[index].b_seq != '') {
                    this.bannerData[index].b_seq = Number(this.bannerData[index].b_seq);
                }
            }
        },
        openRemoveConfirm(idx, index) {
            this.createConfirm({
                content: '해당 배너를 삭제하시겠습니까?',
                confirm: () => {
                    this.allChangeData = true;
                    if(idx === 0) {
                        this.bannerData.splice(index, 1);
                        this.$nextTick(() => {
                            this.allChangeData = false;
                        })
                    }else{
                        this.selectIndex = index;
                        this.DeleteClass.runDelete(idx);
                    }
                }

            })
        },
        addBanner() {
            if(this.bannerData.length >= 15) {
                this.errorAlert('배너는 15개 이상 추가할 수 없습니다.')
                return false;
            }
            let data = {
                "b_idx": 0, //배너번호
                "b_seq": 1, //노출순서 숫자가 작을수록 상위노출
                "b_is_show": 0, //노출유무 0:미노출, 1:노출
                "b_url": "",
                "File": [],
                "b_image_type" : "banner",
            }
            this.bannerData.unshift(data);
        },

        onlyOnePhotoChange(file, fileList) {

            let maxSize = this.imageMaxSize;
            let type = file.raw.type.split('/');
            if (file.size > maxSize) {
                this.errorAlert('1회 업로드 가능 용량을 초과했습니다!');
                fileList.pop();
            } else if (!(type[1] === 'jpeg' || type[1] === 'png')) {
                this.errorAlert('이미지 파일만 업로드 가능합니다.')
                fileList.pop();
            } else {

                let dataFile = this.$_.get(this, `${this.fileType}`)
                if (this.fileType === '' || dataFile === undefined) {
                    if (this.files.length > 0 && this.files[0].hasOwnProperty('a_idx') && this.files[0].a_idx != null) {
                        file.a_idx = this.files[0].a_idx;
                    }
                    this.files[0] = file;
                    this.$forceUpdate();
                    if (this.parentChange) {
                        this.parentChange('files', this.files);
                    }
                } else {
                    let dataFile = this.$_.get(this, `${this.fileType}`)
                    if (dataFile.length > 0 && dataFile[0].hasOwnProperty('a_idx') && dataFile[0].a_idx != null) {
                        file.a_idx = dataFile[0].a_idx;
                    }
                    this.$_.set(this, `${this.fileType}`, [file]);
                    this.$forceUpdate();
                    if (this.parentChange) {
                        this.parentChange(this.fileType, this[this.fileType]);
                    }
                }
            }
        },
        runSave(banner, index) {
            if (this.isRunning) return false;
            let checkData = this.checkData(banner);
            if(checkData != true) {
                this.errorAlert(checkData)
                return false;
            }
            this.selectIndex = index;
            if(banner.b_idx === 0) {
                this.createBanner(banner);
            }else{
                this.updateBanner(banner);
            }
            return true;
        },
        checkData(banner) {
            if(util.isEmpty(banner.File) || util.isEmpty(banner.b_seq) || util.isEmpty(banner.b_is_show)) {
                return '모든 데이터를 다 입력해주세요.';
            }
            let bannerIndex = this.beforeBannerData.findIndex(data => data.b_seq == banner.b_seq && data.b_idx != banner.b_idx)
            if(bannerIndex > -1) {
                return '노출 순서가 중복됩니다.';
            }
            let showCount = this.beforeBannerData.filter(data => data.b_is_show == 1 && data.b_idx != banner.b_idx).length;
            if(banner.b_is_show == 1) {
                showCount++;
            }
            if(showCount > 10) {
                return '노출 배너는 10개까지 가능합니다.';
            }
            var expUrl = /^http[s]?\:\/\//i;
            if(!util.isEmpty(banner.b_url) && !expUrl.test(banner.b_url)) {
                return '이동링크는 http, https 가 존재하는 url 형식으로 입력해주세요.'
            }

            return true;
        },
        createBanner(banner) {
            let params = {
                b_seq: banner.b_seq,
                b_is_show: banner.b_is_show,
                b_url: banner.b_url ? banner.b_url : '',
                b_type: 'url',
                b_image_type : banner.b_image_type,
            }
            try {
                this.changeLoading(true);
                this.$api.$banner.createBanner(params).then(res => res.Data.Result).then(res => {
                    if(res.Info.type === 1) {

                        this.uploadFiles(banner.File, 'banner', res.List).then(fileSuccess => {
                            this.saveSuccess(res.List);
                        })
                    }else{
                        this.saveFail();
                    }
                })
            }catch (e) {
                this.changeLoading(false)
                console.log(e);
            }
        },
        updateBanner(banner) {
            let beforeBanner = this.beforeBannerData.filter(data => data.b_idx == banner.b_idx)[0];

            let params = {
                b_idx: banner.b_idx,
                b_seq: banner.b_seq,
                b_is_show: banner.b_is_show,
                b_url: banner.b_url ? banner.b_url : '',
                b_type: 'url',
            }
            /*if(beforeBanner.b_seq === banner.b_seq) {
                delete params.b_seq;
            }*/
            if(beforeBanner.b_is_show === banner.b_is_show) {
                delete params.b_is_show;
            }
            try {
                this.changeLoading(true);
                this.$api.$banner.updateBanner(params).then(res => res.Data.Result).then(res => {
                    if(res.Info.type === 1) {
                        this.uploadFiles(banner.File, 'banner', params.b_idx).then(res => {
                            this.saveSuccess(params.b_idx);
                        })
                    }else{
                        this.saveFail();
                    }
                })
            }catch (e) {
                this.changeLoading(false)
                console.log(e);
            }
        },
        saveSuccess(key) {
            this.getData(key);
            this.createAlert({
                content: '저장되었습니다.',
            })
        },
        saveFail() {
            this.changeLoading(false)
            this.errorAlert('저장에 실패하였습니다.')
        },
        getData(key) {
            if(util.isEmpty(this.selectIndex)) {
                this.changeLoading(false);
                return false;
            }

            let params = {
                ip: 0,
            }
            this.changeData = true;
            params.id = key
            this.$api.$banner.getBanner(params).then(res => res.Data.Result).then(res => {
                this.changeLoading(false);
                if(!util.isEmpty(res.List)) {
                    let bannerData = res.List.filter(data => data.b_idx == key);
                    if(bannerData.length === 0) {
                        this.changeData = false;
                        this.selectIndex = null;

                        return false;
                    }
                    let list = this.bannerData.slice();
                    list[this.selectIndex] = bannerData[0];
                    this.bannerData = [];
                    this.$nextTick(() => {
                        this.bannerData = list;

                    })
                    //this.bannerData[this.selectIndex] = JSON.parse(JSON.stringify(bannerData[0]));
                    let beforeBannerIndex = this.beforeBannerData.findIndex(bb => bb.b_idx == key);
                    if(beforeBannerIndex > -1) {
                        this.beforeBannerData[beforeBannerIndex] = JSON.parse(JSON.stringify(bannerData[0]))
                    }else{
                        this.beforeBannerData.unshift(bannerData[0])
                    }
                    this.$forceUpdate();
                }
                this.changeData = false;
                this.selectIndex = null;
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
